// extracted by mini-css-extract-plugin
export default {"value":"C3Bwk1xWN8gkJXdWlHd0","valuePrimary":"n1gY_D48XkkrgBi2pKwt","tooltip":"tnAdGIRDZCvYjJNMTjwQ"};